import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import VueI18n from 'vue-i18n'
import messages from './lang'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueAuth from '@websanova/vue-auth'
import Router from 'vue-router'
import Decoder from './plugins/decoder'

// import { VMenu } from 'vuetify/lib';
Vue.config.productionTip = false

Vue.use(Router)
Vue.router = router

router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title)

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)
  const previousNearestWithMeta = from.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags)

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(
    el => el.parentNode.removeChild(el)
  )

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next()

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement('meta')

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key])
      })

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute('data-vue-router-controlled', '')

      return tag
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag))

  next()
})

Vue.use(Decoder)

Vue.use(VueAxios, axios)
Vue.axios.defaults.baseURL =
  process.env.NODE_ENV !== 'development'
    ? 'https://ecrman.novumglobal.eu' //'http://localhost:8080'
    : 'https://olp.novumglobal.eu' //'https://ecrman.novumglobal.eu/services'

Vue.use(VueAuth, {
  tokenStore: ['cookie', 'localStorage'],
  auth: require('@websanova/vue-auth/drivers/auth/bearer'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x'),
  loginData: { redirect: '' },
  rolesVar: 'UserLevel',
  parseUserData: function(data) {
    return data
  },
  fetchData: {
    url:
      process.env.NODE_ENV !== 'development'
        ? 'https://ecrman.novumglobal.eu/apigsprovider/Api/Partner/GetPartner'
        : 'https://olpapi.novumglobal.eu/apigsprovider/Api/Partner/GetPartner',
    method: 'GET',
    enabled: true,
    addTrailingSlash: true
  },
  refreshData: {
    url:
      process.env.NODE_ENV !== 'development'
        ? 'https://ecrman.novumglobal.eu/apigsprovider/Api/Access/GetApiToken'
        : 'https://olpapi.novumglobal.eu/apigsprovider/Api/Access/GetApiToken',
    method: 'GET',
    enabled: true,
    addTrailingSlash: true
  }
})

axios.interceptors.response.use(res => {
  // Unauthorized Access

  if (res.status === 401) {
    Vue.auth.logout({
      redirect: { name: '/login' }
    })
  }
  // System Error
  else if (res.status === 500) {
    // Redirect to 500 page
  }
  return res
})

Vue.prototype.$uiURL =
  process.env.NODE_ENV !== 'development'
    ? 'https://ecrman.novumglobal.eu' // 'http://localhost:8080'
    : 'https://olp.novumglobal.eu' //'https://ecrman.novumglobal.eu' //
Vue.prototype.$proxyURL =
  process.env.NODE_ENV !== 'development'
    ? 'https://ecrman.novumglobal.eu'
    : 'https://olp.novumglobal.eu'
Vue.prototype.$providerURL =
  process.env.NODE_ENV !== 'development'
    ? 'https://ecrman.novumglobal.eu/apigsprovider' //http://appvyvoj.novumglobal.eu/apigsprovider'
    : 'https://olpapi.novumglobal.eu/apigsprovider' // 'http://localhost:8080/api'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'cs', // set locale
  messages // set locale messages
})

new Vue({
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
